import type { CatalogResource } from '../../types.js';
import { FEATURE_GROUP_KEYS } from '../feature-groups.js';
import { ROLE_KEYS } from '../roles.js';

const GROUP = FEATURE_GROUP_KEYS.TRACEABILITY;
const defaultGrants = {
  [ROLE_KEYS.COMPANY_ADMIN]: 'all',
  [ROLE_KEYS.COMPANY_CREATOR]: 'all',
  [ROLE_KEYS.COMPANY_READER]: ['read'],
} as const;

export const traceability = [
  {
    key: 'orders',
    name: 'Orders',
    description: 'Purchase and sales orders (tracing)',
    group: GROUP,
    actions: ['read', 'create', 'edit', 'delete'],
    grants: defaultGrants,
  },
  {
    key: 'supply-chain-mapping',
    name: 'Supply Chain Mapping',
    description: 'Supply chain network mapping',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'archive'],
    grants: defaultGrants,
  },
  {
    key: 'product-mapping',
    name: 'Product Mapping',
    description: 'Product-to-supply-chain mapping',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'archive'],
    grants: defaultGrants,
  },
  {
    key: 'certified-materials',
    name: 'Certified Materials Management',
    description: 'Certified material balances and claims',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'delete', 'archive'],
    grants: defaultGrants,
  },
  {
    key: 'entity-screening',
    name: 'Entity Screening',
    description: 'Sanctions and risk-list screening',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'delete', 'archive'],
    grants: defaultGrants,
  },
  {
    key: 'files',
    name: 'Files Management',
    description: 'Tracing documents and their file history',
    group: GROUP,
    actions: ['read', 'create', 'edit', 'delete'],
    grants: defaultGrants,
  },
  {
    key: 'automation-rules',
    name: 'Automation Rules',
    description: 'Workflow automation rules',
    group: GROUP,
    actions: ['read', 'create', 'edit', 'delete', 'archive'],
    grants: defaultGrants,
  },
] as const satisfies readonly CatalogResource[];
